import React, { useEffect, useState } from 'react';
import '../Estilos/Componentes.css';
import useWindowSize from '../Hooks/windowSize';

export default function TopicoTexto(props) {
  const windowSize = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(windowSize.width < 768);
  }, [windowSize]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: props.altura !== undefined ? props.altura : 80,
        justifyContent: 'flex-start',
        minWidth: isMobile ? '-webkit-fill-available' : 380,
        marginBottom: props.bottom ? props.bottom : 0,
        width: props.largura ? props.largura : '100%',
        marginLeft: props.marginLeft ? props.marginLeft : 0,
      }}
    >
      <h4 id="FonteTopico">{props.titulo}</h4>
      <div className="header-subline" style={{ height: 3, backgroundColor: '#9AB3D5', width: 115, fontWeight: '100' }}></div>
    </div>
  );
}
